import { render, staticRenderFns } from "./gj-upload-img.vue?vue&type=template&id=2ef6b41e&scoped=true&"
import script from "./gj-upload-img.vue?vue&type=script&lang=js&"
export * from "./gj-upload-img.vue?vue&type=script&lang=js&"
import style0 from "./gj-upload-img.vue?vue&type=style&index=0&id=2ef6b41e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef6b41e",
  null
  
)

export default component.exports